import type { Client } from 'utils/webrtc/Client';
import { PCContext } from 'utils/webrtc/stats/types';

export type PolledPC = {
  pcKey: string;
  pc: RTCPeerConnection;
  context: PCContext;
};

// Look up PCs via the feeds' getPeerConnection so Janus internals don't leak into orchestrator code.
export const collectPCs = (rtcClient: Client): PolledPC[] => {
  const out: PolledPC[] = [];

  const pubPC = rtcClient.publishingFeed.getPeerConnection();
  if (pubPC) {
    out.push({ pcKey: 'pub', pc: pubPC, context: { pcKey: 'pub', isPublishing: true } });
  }

  const ssPC = rtcClient.screensharingFeed.getPeerConnection();
  if (ssPC) {
    out.push({ pcKey: 'ss-pub', pc: ssPC, context: { pcKey: 'ss-pub', isPublishing: true } });
  }

  const recvPC = rtcClient.receivingFeed.getPeerConnection();
  if (recvPC) {
    out.push({ pcKey: 'rcv', pc: recvPC, context: { pcKey: 'rcv', isPublishing: false } });
  }

  return out;
};
